import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSystemLogin } from '../contexts/SystemLoginContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * 受保护的路由组件
 * 如果用户未登录，则重定向到登录页面
 * 登录成功后会自动返回到原来想要访问的页面
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  redirectTo = '/login' 
}) => {
  const { isLoggedIn, isLoginNeeded } = useSystemLogin();
  const location = useLocation();

  // 如果需要登录或者用户未登录，则重定向到登录页面
  if (isLoginNeeded || !isLoggedIn) {
    return (
      <Navigate 
        to={redirectTo} 
        state={{ from: location.pathname }} 
        replace 
      />
    );
  }

  // 用户已登录，渲染子组件
  return <>{children}</>;
};

export default ProtectedRoute; 